import React from 'react';
import { SlideContent } from '../components/canvas/SlideContent';
import { SlideFooter } from '../components/canvas/SlideFooter';
import { SlideLogo } from '../components/canvas/SlideLogo';
import { NudgeableGroup } from '../components/canvas/NudgeableGroup';

/**
 * Dynamic Diagonal layout — bold/energetic style.
 * Diagonal dark band sweeps across the slide with an accent border.
 * Footer pinned at bottom for cross-template consistency.
 */
export function DynamicDiagonalLayout({ data, fontPreset, logoEnabled = true, logoUrl = null, logoSize = null, logoIsDark = false, pc }) {
  return (
    <div className="absolute inset-0">
      {/* Diagonal dark band */}
      <div
        className="absolute inset-0"
        style={{
          clipPath: 'polygon(0 15%, 100% 5%, 100% 85%, 0 95%)',
          backgroundColor: pc.surfaceAt(0.70),
        }}
      >
        {/* Top accent border */}
        <div
          className="absolute top-0 left-0 right-0 h-[3px]"
          style={{ backgroundColor: pc.accent(0.50) }}
        />
      </div>

      {/* Logo — independently nudgeable */}
      {logoEnabled && (
        <NudgeableGroup groupId="logo" className="absolute top-[15%] left-[80px]" style={{ paddingTop: '48px' }}>
          <SlideLogo className="h-14 w-14" style={{ color: pc.text(0.70) }} logoUrl={logoUrl} size={logoSize} isDark={logoIsDark} />
        </NudgeableGroup>
      )}

      {/* Content */}
      <NudgeableGroup groupId="content" className="absolute inset-0 flex flex-col justify-center px-[80px] pb-[140px]">
        {/* Spacer to offset for logo area */}
        {logoEnabled && <div className="h-[80px] shrink-0" />}

        <SlideContent
          data={data}
          fontPreset={fontPreset}
          pc={pc}
          options={{
            showFooter: false,
            subtleOpacity: 0.50,
          }}
        />
      </NudgeableGroup>

      {/* Footer — pinned at bottom */}
      <div className="absolute bottom-[64px] left-[64px] right-[64px]">
        <SlideFooter data={data} pc={pc} />
      </div>
    </div>
  );
}
